import { styled } from '@nykaa/ui-components';
import Product from 'shared/layouts/Listing/components/ProductPlaceholder';

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Content = styled(FlexRow)`
  flex: 1;
`;

export const Skeleton = styled(FlexColumn)`
  margin: ${({ theme }) => `${theme.spacing.spacing320} ${theme.spacing.spacing240} `};
`;

export const ProductsArea = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const Sort = styled.div`
  align-self: flex-end;
  width: 270px;
  background-size: auto;
  min-height: 40px;
  background-color: ${({ theme }) => theme.colors.surface20};
`;

export const ProductPlaceholder = styled(Product)`
  width: calc(25% - ${({ theme }) => theme.spacing.spacing120});
  margin: ${({ theme }) =>
    `${theme.spacing.spacing160} ${theme.spacing.spacing0} ${theme.spacing.spacing160} ${theme.spacing.spacing120}`};
`;

export const Filter = styled.div`
  min-height: 100vh;
  background-size: auto;
  width: ${({ theme }) => `calc(20% - ${theme.spacing.spacing240})`};
  background-color: ${({ theme }) => theme.colors.surface20};
`;

export const Title = styled.div`
  min-height: 24px;
  width: 300px;
  background-size: auto;
  background-color: ${({ theme }) => theme.colors.surface20};
  margin-bottom: ${({ theme }) => theme.spacing.spacing120};
`;

export const Widget = styled.div`
  width: 100%;
  min-height: 286px;
  background-size: auto;
  margin-bottom: ${({ theme }) => theme.spacing.spacing120};
  background-color: ${({ theme }) => theme.colors.surface20};
`;
